(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/advanced-options.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/advanced-options.js');
'use strict';

const {
  useContext
} = React;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  url
} = svs.utils;
const {
  resolveProductId
} = svs.utils.products;
const {
  Inputv2: Input
} = svs.ui.reactForm;
const {
  createBetProposal
} = svs.components.marketplaceData;
const {
  getDraw,
  getDrawEvents,
  selectDrawEventsErrorMessage
} = svs.components.marketplaceData.selectors.draws;
const {
  selectCreateBetProposal
} = svs.components.marketplaceData.selectors.betProposal;
const {
  selectCreateGame
} = svs.components.marketplaceData.selectors.createGame;
const {
  BetProposalCreate
} = svs.components.marketplace.betProposal;
const {
  getRowId
} = svs.components.marketplace.helpers;
const {
  excludedProducts
} = svs.components.marketplace.betProposal;
const {
  EventListContainer
} = svs.components.marketplace.eventList;
const {
  MarketplaceBrandContext
} = svs.components.marketplace.marketplaceBrand;
const {
  changeDescription
} = svs.components.marketplaceData.createGame.actions;
const AdvancedOptions = _ref => {
  let {
    groupId,
    activatedDrawId,
    isEditMode
  } = _ref;
  const dispatch = useDispatch();
  const {
    getBrandedDisplayName
  } = useContext(MarketplaceBrandContext);
  const drawEventsErrorMessage = useSelector(selectDrawEventsErrorMessage);
  const {
    selectedDraw: drawNumber,
    selectedProduct: productName
  } = useSelector(selectCreateGame);
  const {
    description
  } = useSelector(state => state.CreateGame);
  const betProposalRowId = activatedDrawId || getRowId(productName, drawNumber, groupId);
  const {
    raceId
  } = useSelector(state => getDraw(state, {
    drawNumber,
    productName
  }));
  const drawEvents = useSelector(state => getDrawEvents(state, {
    drawNumber,
    productName
  }));
  const betProposal = useSelector(state => selectCreateBetProposal(state, {
    activatedDrawId: betProposalRowId
  })) || {};
  let betProposalElement;
  if (drawEventsErrorMessage) {
    betProposalElement = React.createElement("span", {
      className: "f-bold block margin-bottom-half",
      "data-testid": "bet-proposal-error"
    }, drawEventsErrorMessage);
  } else if (productName && excludedProducts[url.encode(productName.toLowerCase())]) {
    betProposalElement = React.createElement(EventListContainer, {
      activatedDrawId: activatedDrawId,
      drawNumber: drawNumber,
      events: drawEvents || [],
      groupId: groupId,
      productName: productName,
      warningMessage: "Det g\xE5r inte att g\xF6ra n\xE5gon radskiss till ".concat(getBrandedDisplayName(resolveProductId(productName)), ".")
    });
  } else {
    betProposalElement = React.createElement("div", {
      className: "margin-top-2 margin-bottom-2"
    }, React.createElement(BetProposalCreate, {
      drawNumber: drawNumber,
      events: drawEvents || [],
      isDisabled: false,
      isLoading: isNaN(raceId) && !drawEvents || isNaN(raceId) && (drawEvents === null || drawEvents === void 0 ? void 0 : drawEvents.length) <= 0,
      onClearRow: () => {
        dispatch(createBetProposal.actions.clearRow(activatedDrawId, productName, drawNumber, groupId));
      },
      productName: productName,
      raceId: raceId,
      selectedOutcomes: betProposal,
      toggleOutcome: event => {
        dispatch(createBetProposal.actions.toggleOutcome(activatedDrawId, event, productName, drawNumber, groupId, event.participantNumber));
      }
    }));
  }
  return React.createElement("div", {
    "data-testid": "qa-advanced-options"
  }, betProposalElement, React.createElement("div", {
    className: "control-group input-v2-bg-white margin-bottom-2"
  }, React.createElement(Input, {
    className: "description-input qa-description",
    id: "create-game-input-description",
    label: "Meddelande",
    maxLength: 900,
    multiline: true,
    onChange: _ref2 => {
      let {
        target
      } = _ref2;
      return dispatch(changeDescription(target.value));
    },
    placeholder: "Kort beskrivning av spelet",
    value: description
  })));
};
setGlobal('svs.components.marketplace.createGame.AdvancedOptions', AdvancedOptions);

 })(window);